import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import { oneAssetApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FundriskService = /** @class */ (function () {
    function FundriskService(http) {
        this.http = http;
    }
    FundriskService.prototype.get_riskLevelByRiskID = function (riskid) {
        var URL = cmsApi + '/get_riskLevelByRiskID';
        var body = { riskid: riskid };
        return this.http.post(URL, body);
    };
    FundriskService.prototype.getFundRiskMapp = function (fundtype, riskid) {
        var URL = cmsApi + '/getFundRiskMapp';
        var body = {
            fundtype: fundtype,
            riskid: riskid
        };
        return this.http.post(URL, body);
    };
    FundriskService.prototype.getTopFund = function () {
        var URL = cmsApi + '/get_fund_recomend_2';
        var body = {};
        return this.http.post(URL, body);
    };
    FundriskService.prototype.getTopFund_all = function () {
        var URL = cmsApi + '/get_fund_recomend_all_2';
        var body = {};
        return this.http.post(URL, body);
    };
    FundriskService.prototype.getFundByType = function (fundtype) {
        var URL = cmsApi + '/get_fund_recomend_2_by_type';
        var body = { fundtype: fundtype };
        return this.http.post(URL, body);
    };
    FundriskService.prototype.GetAssumption = function () {
        var URL = oneAssetApi + '/Fund/GetAssumption';
        return this.http.get(URL);
    };
    FundriskService.ngInjectableDef = i0.defineInjectable({ factory: function FundriskService_Factory() { return new FundriskService(i0.inject(i1.HttpClient)); }, token: FundriskService, providedIn: "root" });
    return FundriskService;
}());
export { FundriskService };
